var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label-container"},[_c('div',{staticClass:"label-content",class:{ 'label-prepend': _vm.prepend }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }